import { LineSeparatorPositionType } from '@kubit/web-ui-components/lineSeparator/types';
import { DraggableItemStateType } from '../../../../../../components/draggableItem/types/draggableItemStateType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { CheckboxVariantType, DraggableItemVariantType, IconButtonSizeType, IconButtonVariantType, LineSeparatorLineVariantType, SelectionIndicatorVariantType, TextVariantType, } from '../../variants';
const commonStateStyles = (FOUNDATIONS, styles) => {
    return {
        rootContainer: {
            width: '100%',
            display: 'flex',
            flex_direction: 'row',
            align_items: 'center',
            padding_left: FOUNDATIONS.spacing_150,
            padding_right: FOUNDATIONS.spacing_100,
            gap: FOUNDATIONS.spacing_250,
            ...styles.rootContainer,
        },
        lineSeparator: {
            ...styles.lineSeparator,
        },
        leftContainer: {
            flex_grow: '1',
            display: 'flex',
            flex_direction: 'row',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_250,
            padding_top: FOUNDATIONS.spacing_250,
            padding_bottom: FOUNDATIONS.spacing_250,
            ...styles.leftContainer,
        },
        draggableIconContainer: {
            cursor: 'pointer',
            ...styles.draggableIconContainer,
        },
        draggableIcon: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_comp_forms_draggableitem_draggable_icon,
            ...styles.draggableIcon,
        },
        selectorsTextsContainer: {
            flex_grow: '1',
            display: 'flex',
            flex_direction: 'row',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_250,
            position: 'relative',
            ...styles.selectorsTextsContainer,
        },
        input: {
            position: 'absolute',
            top: '0',
            bottom: '0',
            left: '0',
            right: '0',
            cursor: 'pointer',
            ...styles.input,
        },
        selectionIndicator: {
            variant: SelectionIndicatorVariantType.DEFAULT,
            ...styles.selectionIndicator,
        },
        checkbox: {
            variant: CheckboxVariantType.REGULAR,
            ...styles.checkbox,
        },
        icon: {
            width: FOUNDATIONS.size_350,
            height: FOUNDATIONS.size_350,
            color: FOUNDATIONS.color_secondary_icon_100,
            ...styles.icon,
        },
        textsContainer: {
            flex_grow: '1',
            display: 'flex',
            flex_direction: 'column',
            align_items: 'flex-start',
            gap: FOUNDATIONS.spacing_100,
            ...styles.textsContainer,
        },
        title: {
            font_variant: TextVariantType.FONT_PARAGRAPH_250,
            font_weight: FONT_WEIGHT.font_weight_600,
            color: FOUNDATIONS.color_neutral_font_50,
            ...styles.title,
        },
        description: {
            font_variant: TextVariantType.FONT_PARAGRAPH_500,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_neutral_font_100,
            ...styles.description,
        },
        rightContainer: {
            display: 'flex',
            flex_direction: 'row',
            column_gap: FOUNDATIONS.spacing_150,
            ...styles.rightContainer,
        },
        firstChevronIcon: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_comp_actions_iconbutton_secondary_default_icon,
            ...styles.firstChevronIcon,
            disabled: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_accent_disabled_icon_100,
                ...styles.firstChevronIcon?.disabled,
            },
        },
        secondChevronIcon: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_comp_actions_iconbutton_secondary_default_icon,
            ...styles.secondChevronIcon,
            disabled: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_accent_disabled_icon_100,
                ...styles.secondChevronIcon?.disabled,
            },
        },
        firstChevronIconButton: {
            variant: IconButtonVariantType.SECONDARY,
            size: IconButtonSizeType.SMALL,
            ...styles.firstChevronIconButton,
        },
        secondChevronIconButton: {
            variant: IconButtonVariantType.SECONDARY,
            size: IconButtonSizeType.SMALL,
            ...styles.firstChevronIconButton,
        },
        blockedIcon: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_accent_disabled_icon_50,
            ...styles.secondChevronIcon,
        },
    };
};
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [DraggableItemVariantType.DEFAULT]: {
            [DraggableItemStateType.DEFAULT_UNSELECTED]: commonStateStyles(FOUNDATIONS, {
                lineSeparator: {
                    variant: LineSeparatorLineVariantType.DEFAULT_HORIZONTAL,
                    position: LineSeparatorPositionType.BOTTOM,
                },
            }),
            [DraggableItemStateType.DEFAULT_SELECTED]: commonStateStyles(FOUNDATIONS, {
                lineSeparator: {
                    variant: LineSeparatorLineVariantType.DEFAULT_HORIZONTAL,
                    position: LineSeparatorPositionType.BOTTOM,
                },
            }),
            [DraggableItemStateType.PRESSED_UNSELECTED]: commonStateStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_pressed_bgcolor,
                },
                lineSeparator: {
                    variant: LineSeparatorLineVariantType.DEFAULT_HORIZONTAL,
                    position: LineSeparatorPositionType.BOTTOM,
                },
            }),
            [DraggableItemStateType.PRESSED_SELECTED]: commonStateStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_pressed_bgcolor,
                },
                lineSeparator: {
                    variant: LineSeparatorLineVariantType.DEFAULT_HORIZONTAL,
                    position: LineSeparatorPositionType.BOTTOM,
                },
            }),
            [DraggableItemStateType.DRAGGED_UNSELECTED]: commonStateStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_comp_forms_draggableitem_draggable_bg,
                },
            }),
            [DraggableItemStateType.DRAGGED_SELECTED]: commonStateStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_comp_forms_draggableitem_draggable_bg,
                },
            }),
            [DraggableItemStateType.DISABLED_UNSELECTED]: commonStateStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                lineSeparator: {
                    variant: LineSeparatorLineVariantType.DECORATIVE_HORIZONTAL,
                    position: LineSeparatorPositionType.BOTTOM,
                },
                input: {
                    cursor: 'default',
                },
            }),
            [DraggableItemStateType.DISABLED_SELECTED]: commonStateStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                lineSeparator: {
                    variant: LineSeparatorLineVariantType.DECORATIVE_HORIZONTAL,
                    position: LineSeparatorPositionType.BOTTOM,
                },
                input: {
                    cursor: 'default',
                },
            }),
            [DraggableItemStateType.BLOCKED_UNSELECTED]: commonStateStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                lineSeparator: {
                    variant: LineSeparatorLineVariantType.DECORATIVE_HORIZONTAL,
                    position: LineSeparatorPositionType.BOTTOM,
                },
                input: {
                    cursor: 'default',
                },
            }),
            [DraggableItemStateType.BLOCKED_SELECTED]: commonStateStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                lineSeparator: {
                    variant: LineSeparatorLineVariantType.DECORATIVE_HORIZONTAL,
                    position: LineSeparatorPositionType.BOTTOM,
                },
                input: {
                    cursor: 'default',
                },
            }),
        },
    };
};
//# sourceMappingURL=default.js.map